import { writable, derived } from 'svelte/store';
import { tweened } from 'svelte/motion';
import { cubicOut } from 'svelte/easing';
import { flatten, groupBy } from 'lodash-es';
import { calculateEmissions } from './utils/emissions';
import { QUESTIONS_DEF } from './constants/questions_def';
export const progress = tweened(0, {
    duration: 300,
    easing: cubicOut,
});
export const progressCount = writable(0);
export const surveyStatus = writable({
    currentQuestionId: 'start_survey',
    currentUserAnswer: [
        {
            questionId: 'start_survey',
            id: 'start_survey_1',
            text: '',
            nextQuestionId: (userAnswersList) => 'municipality_of_residence',
        },
    ],
    userAnswersList: [],
});
export const answersByQuestionId = derived(surveyStatus, ($surveyStatus) => groupBy(flatten($surveyStatus.userAnswersList).filter((a) => !a.isOldAnswer), 'questionId'));
export const currentQuestion = derived(surveyStatus, ($surveyStatus) => QUESTIONS_DEF.find((question) => question.id === $surveyStatus.currentQuestionId));
export const emissions = derived(surveyStatus, ($surveyStatus) => {
    return calculateEmissions($surveyStatus.userAnswersList);
});
export const canGoNext = derived([surveyStatus, currentQuestion], ([$surveyStatus, $currentQuestion]) => {
    var _a, _b, _c;
    if ($currentQuestion && $currentQuestion.isSkippable)
        return true;
    if ((_a = $surveyStatus.currentUserAnswer[0]) === null || _a === void 0 ? void 0 : _a.isOpenAnswer)
        return Boolean((_b = $surveyStatus.currentUserAnswer[0]) === null || _b === void 0 ? void 0 : _b.openAnswerText);
    return ((_c = $surveyStatus.currentUserAnswer) === null || _c === void 0 ? void 0 : _c.length) > 0;
});
export const stage = writable(null);
export const portraitLayer = writable(null);
export const aboutModal = writable(null);
export const modalAnswerList = writable(null);
export const modalUserId = writable(null);
